<template>
    <div class="element-box p-0">
        <div class="element-content p-3">
            <h6 class="element-header capitalize" v-text="type === 'update' ? t.edit : t.create_user"></h6>
            <symForm :options="opt" :data="formData" v-on:sended="getUserForm" :form="userForm" :formProcess="formProcess"
                     v-if="userForm"/>
        </div>

    </div>
</template>

<script>
    import symForm from '@/components/form/symForm.vue'

    export default {
        name: 'userEdit',
        components: {symForm},
        props: ['type'],
        data() {
            return {
                session: session,
                userLoader: true,
                t: this.$root.t,
                users: null,
                regions: [],
                breadcrumb: [],
                userOpened: false,
                userForm: null,
                formProcess: 0,
                opt: {
                    region: {data: [], label: 'nationallity'},
                },
                formData: [],
                registeredData: null
            }
        },
        mounted() {
            this.getUserForm();
        },
        notifications: {
            showFormError: { // You can have any name you want instead of 'showLoginError'
                title: 'Login Failed',
                message: 'Failed to authenticate',
                type: 'error' // You also can use 'VueNotifications.types.error' instead of 'error'
            }
        },
        methods: {
            async getUserForm(data) {

                this.userForm = null;
                this.formProcess = 0;
                this.$bus.$emit('globalLoader', true);
                if (data) {
                    var ref = (this.$route.query.ref) ? this.$route.query.ref : '';
                    //this.userForm = null;
                    this.$http.post(api + 'api/v1/user/virtual-user-edit/' + this.$route.params.id,
                        data)
                        .then(response => {

                            this.registeredData = response.body.data;
                            this.userForm = response.body.result;
                            this.formProcess = 200;

                            //swal('', this.t.registration.success, "success")
                            this.$bus.$emit('globalLoader', false);

                            if (response.body.data) {
                                //this.$router.replace({name: 'CustomerDetail', params: {id: response.body.data.userId}})
                            }

                            this.getUserForm()

                        }, response => {
                            this.userForm = response.body.result;
                            this.formProcess = 400;
                            swal(this.t.processing.error, this.t.processing.check, "error")
                            this.$bus.$emit('globalLoader', false);
                        })

                } else {
                    this.$http.get(api + 'api/v1/user/virtual-user-edit/'+ this.$route.params.id)
                        .then(response => {

                            this.userForm = response.body.result;
                            this.formData = response.body.form_data;
                            this.opt.region.data = this.regions;
                            this.opt.region.label = 'name';
                            this.$bus.$emit('globalLoader', false);

                        }, response => {
                            this.$bus.$emit('globalLoader', false);
                        })
                }

            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/views/UserEdit.vue